import { useFlags } from '@lendi/launchdarkly';
import { Brand } from '@lendi/lala-utils';
import { useSession } from '@lendi/lala-react';
import { useEffect, useState } from 'react';
export var useDisableChat = function () {
    var _a = useState(true), isChatDisabled = _a[0], setIsChatDisabled = _a[1];
    var _b = useFlags(), disableChat = _b.disableChat, enableAussieChat = _b.enableAussieChat;
    var brand = useSession().brand;
    useEffect(function () {
        if (brand === Brand.Aussie) {
            if (enableAussieChat !== undefined)
                setIsChatDisabled(!enableAussieChat);
        }
        else {
            if (disableChat !== undefined)
                setIsChatDisabled(disableChat);
        }
    }, [disableChat, enableAussieChat, brand]);
    return isChatDisabled;
};
//# sourceMappingURL=index.js.map